import { useCheckDevice } from '@hooks/UseCheckDevice';
import { Dispatch, FC, SetStateAction } from 'react';
import Modal from 'react-modal';
import SelectStore from '../../select-store/SelectStore';

type SelectStoreModalProps = {
  modalIsOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const SelectStoreModal: FC<SelectStoreModalProps> = ({ modalIsOpen, setIsOpen }) => {
  const onClose = (): void => {
    setIsOpen(false);
  };
  const { isMobileDevice } = useCheckDevice();

  const customStyles = {
    content: {
      top: isMobileDevice ? '45px' : '60px',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, 2%)',
      width: isMobileDevice ? '100vw' : '640px',
      minHeight: '300px',
      maxHeight: '640px',
      zIndex: 100000,
      padding: '0',
    },
  };
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel='Select Store Modal'
      overlayClassName='select-store-modal'
    >
      <SelectStore openedFromModal={true} closeModal={onClose} />
    </Modal>
  );
};

export default SelectStoreModal;
